import styled from 'styled-components';
const getCheckboxSize = (size) => (size === 'medium' ? 24 : 20);
const backgroundColor = (checked, hasError, hover) => {
    if (hasError)
        return 'var(--checkbox-background-color-error)';
    if (checked && hover)
        return 'var(--checkbox-background-color-checked-hover)';
    if (checked)
        return 'var(--checkbox-background-color-checked)';
    if (hover)
        return 'var(--checkbox-background-color-hover)';
    return 'var(--checkbox-background-color-base)';
};
const borderColor = (checked, hasError, hover) => {
    if (hasError)
        return 'var(--checkbox-border-color-error)';
    if (checked && hover)
        return 'var(--checkbox-background-color-checked-hover)';
    if (checked)
        return 'var(--checkbox-background-color-checked)';
    if (hover)
        return 'var(--checkbox-border-color-hover)';
    return 'var(--checkbox-border-color-base)';
};
export const ContainerLabel = styled.label `
  width: fit-content;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;
  border-radius: var(--border-radius-xxs);

  ${({ disabled }) => disabled &&
    `
      opacity: var(--opacity-intense);
      cursor: not-allowed;
    `};
`;
export const NativeInput = styled.input `
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
`;
export const SpanInput = styled.span `
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ size }) => getCheckboxSize(size)}px;
  width: ${({ size }) => getCheckboxSize(size)}px;
  max-width: ${({ size }) => getCheckboxSize(size)}px;
  min-height: ${({ size }) => getCheckboxSize(size)}px;
  height: ${({ size }) => getCheckboxSize(size)}px;
  max-height: ${({ size }) => getCheckboxSize(size)}px;
  padding: var(--spacing-0-25);
  border-radius: var(--border-radius-xs);
  :focus-within {
    outline: var(--color-neutral-130) solid var(--border-width-thin);
    /* outline-offset: var(--border-width-thin); */
  }
`;
export const LabelWrapper = styled.span `
  margin-left: ${({ size }) => (size === 'medium' ? 'var(--spacing-1)' : 'var(--spacing-0-5)')};
`;
export const CheckboxInputStylized = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => (size === 'small' ? '12px' : '100%')};
  height: ${({ size }) => (size === 'small' ? '12px' : '100%')};
  background-color: ${({ checked, hasError }) => backgroundColor(checked, hasError, false)};
  border-color: ${({ checked, hasError }) => borderColor(checked, hasError, false)};
  border-width: var(--border-width-hairline);
  border-radius: var(--border-radius-xxs);
  border-style: solid;

  ${ContainerLabel}:hover:not([disabled]) & {
    background-color: ${({ checked, hasError }) => backgroundColor(checked, hasError, true)};
    border-color: ${({ checked, hasError }) => borderColor(checked, hasError, true)};
  }

  ${ContainerLabel}:active:not([disabled]) & {
    transform: scale(0.92);
  }

  svg {
    fill: var(--checkbox-color-icon);
  }
`;
export const ErrorMessageWrapper = styled.div `
  display: grid;
  grid-template-columns: 16px auto;
  column-gap: 4px;
  margin-top: var(--spacing-0-5);

  * {
    color: var(--color-feedback-error-100);
  }
`;
